import { LoggedInUsers } from '@/types/service-response'
import moment from 'moment'

export class LoggedInUser {
  public constructor (
    readonly position: number,
    readonly ID: number,
    readonly Kurzzeichen: string | null,
    readonly VorName: string | null,
    readonly Name: string | null,
    readonly Token: string | null,
    readonly UserHostAddress: string | null,
    readonly Browser: string | null,
    readonly CreatedAt: string | null,
    readonly AssignedBrowserName: string | null
  ) {}

  static createFromResponse (responseData: LoggedInUsers[]): Array<LoggedInUser> {
    let result: Array<LoggedInUser> = []
    if (responseData) {
      result = responseData.map((item: LoggedInUsers, index: number) => {
        return new LoggedInUser(
          index,
          item.ID,
          item.Kurzzeichen,
          item.VorName,
          item.Name,
          item.Token,
          item.UserHostAddress,
          item.Browser,
          item.CreatedAt ? moment(item.CreatedAt).format('DD.MM.YYYY HH:mm:ss') : '',
          item.AssignedBrowserName
        )
      })
    }
    return result
  }
}
